import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Tip } from '../timeline-item.types';
import { TipService } from './tip.service';
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: 'tip',
    styleUrls: ['./tip.component.scss'],
    templateUrl: './tip.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule
    ]
})
export class TipComponent implements OnDestroy {

    @Input({ required: true })
    tip!: Tip;

    protected show: boolean = true;

    private _destroy$ = new Subject<void>();

    constructor(private tipService: TipService) {

    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    showTip(tip: Tip) {
        this.tipService.showTips(tip).pipe(
            takeUntil(this._destroy$)
        ).subscribe();
    }

    dismiss(tip: Tip) {
        this.show = false;
        this.tipService.dismissTips(tip).pipe(
            takeUntil(this._destroy$)
        ).subscribe();
    }
}